import { lazy } from "react";

// Single source of truth for page chunks — enables route code-splitting + hover prefetch
export const importers = {
  Dashboard: () => import("@/pages/Dashboard"),
  WorkspacePage: () => import("@/pages/WorkspacePage"),
  DirectorsPage: () => import("@/pages/DirectorsPage"),
  CustomersPage: () => import("@/pages/CustomersPage"),
  CustomerDetailPage: () => import("@/pages/CustomerDetailPage"),
  ManufacturingPage: () => import("@/pages/ManufacturingPage"),
  StockPage: () => import("@/pages/StockPage"),
  StageFlowPage: () => import("@/pages/StageFlowPage"),
  QualityPage: () => import("@/pages/QualityPage"),
  HelpPage: () => import("@/pages/HelpPage"),
  PurchasePage: () => import("@/pages/PurchasePage"),
  JobWorkPage: () => import("@/pages/JobWorkPage"),
  SizeAnalysisPage: () => import("@/pages/SizeAnalysisPage"),
  FulfillmentPage: () => import("@/pages/FulfillmentPage"),
  ChatPage: () => import("@/pages/ChatPage"),
  SalesOrderPage: () => import("@/pages/SalesOrderPage"),
  OrderBookPage: () => import("@/pages/OrderBookPage"),
  OffersPage: () => import("@/pages/OffersPage"),
  QuotationsPage: () => import("@/pages/QuotationsPage"),
  DispatchPage: () => import("@/pages/DispatchPage"),
  PlanningPage: () => import("@/pages/PlanningPage"),
  PlanningIntakePage: () => import("@/pages/PlanningIntakePage"),
  ProcessCardsPage: () => import("@/pages/ProcessCardsPage"),
  ConsumablesPage: () => import("@/pages/ConsumablesPage"),
  ReconciliationPage: () => import("@/pages/ReconciliationPage"),
  HandoverPage: () => import("@/pages/HandoverPage"),
  JobsPage: () => import("@/pages/JobsPage"),
  PlugLogPage: () => import("@/pages/PlugLogPage"),
  TasksPage: () => import("@/pages/TasksPage"),
  GoLivePage: () => import("@/pages/GoLivePage"),
  QuotesPage: () => import("@/pages/QuotesPage"),
  DataFixPage: () => import("@/pages/DataFixPage"),
  WeekPlanPage: () => import("@/pages/WeekPlanPage"),
  MtcPage: () => import("@/pages/MtcPage"),
  InspectionsPage: () => import("@/pages/InspectionsPage"),
  IncomingRmPage: () => import("@/pages/IncomingRmPage"),
  ApprovalsPage: () => import("@/pages/ApprovalsPage"),
  PortalRequestsPage: () => import("@/pages/PortalRequestsPage"),
  PricesViewPage: () => import("@/pages/PricesViewPage"),
  StandardsLibraryPage: () => import("@/pages/StandardsLibraryPage"),
  DailyRatesPage: () => import("@/pages/DailyRatesPage"),
  RatesPinPage: () => import("@/pages/RatesPinPage"),
  DprPage: () => import("@/pages/DprPage"),
  SettingsPage: () => import("@/pages/SettingsPage"),
  OdooArchitecturePage: () => import("@/pages/OdooArchitecturePage"),
  CameraScanPage: () => import("@/pages/CameraScanPage"),
  SopBundlesPage: () => import("@/pages/SopBundlesPage"),
  BundleWallPage: () => import("@/pages/BundleWallPage"),
  ScanPage: () => import("@/pages/ScanPage"),
  PortalPage: () => import("@/pages/PortalPage"),
  BrokerPricesPage: () => import("@/pages/BrokerPricesPage"),
  WorkEntryPage: () => import("@/pages/WorkEntryPage"),
  StockRegisterPage: () => import("@/pages/StockRegisterPage"),
  GatePinPage: () => import("@/pages/GatePinPage"),
  GateRegisterPage: () => import("@/pages/GateRegisterPage"),
  AckSignPage: () => import("@/pages/AckSignPage"),
  HrPage: () => import("@/pages/HrPage"),
  JobRolesPage: () => import("@/pages/JobRolesPage"),
  OrgChartPage: () => import("@/pages/OrgChartPage"),
  PeopleMasterPage: () => import("@/pages/PeopleMasterPage"),
  ReportsPage: () => import("@/pages/ReportsPage"),
  DocumentsPage: () => import("@/pages/DocumentsPage"),
  OrgReviewPage: () => import("@/pages/OrgReviewPage"),
  JdIntakePage: () => import("@/pages/JdIntakePage"),
  ManpowerPage: () => import("@/pages/ManpowerPage"),
  MaintenancePage: () => import("@/pages/MaintenancePage"),
  ComplaintsPage: () => import("@/pages/ComplaintsPage"),
  ProjectsPage: () => import("@/pages/ProjectsPage"),
  AmcPage: () => import("@/pages/AmcPage"),
  VisitorInvitePage: () => import("@/pages/VisitorInvitePage"),
  StockRegisterViewPage: () => import("@/pages/StockRegisterViewPage"),
  SharedSOPage: () => import("@/pages/SharedSOPage"),
  SharedQuotePage: () => import("@/pages/SharedQuotePage"),
  MtcVerifyPage: () => import("@/pages/MtcVerifyPage"),
  SignRemotePage: () => import("@/pages/SignRemotePage"),
  FloorDprPage: () => import("@/pages/FloorDprPage"),
  ProdEntryPage: () => import("@/pages/ProdEntryPage"),
  TvScreenPage: () => import("@/pages/TvScreenPage"),
};

export const P = Object.fromEntries(Object.entries(importers).map(([k, f]) => [k, lazy(f)]));

// route path → chunk importer, used for hover-prefetch on sidebar links
const ROUTE_MAP = {
  "/": "Dashboard", "/workspace": "WorkspacePage", "/directors": "DirectorsPage", "/customers": "CustomersPage",
  "/manufacturing": "ManufacturingPage", "/stock": "StockPage", "/stage-flow": "StageFlowPage", "/quality": "QualityPage",
  "/help": "HelpPage", "/purchase": "PurchasePage", "/jobwork": "JobWorkPage", "/size-analysis": "SizeAnalysisPage",
  "/fulfillment": "FulfillmentPage", "/chat": "ChatPage", "/sales-orders": "SalesOrderPage", "/order-book": "OrderBookPage",
  "/offers": "OffersPage", "/quotes": "QuotationsPage", "/dispatch": "DispatchPage", "/planning": "PlanningPage",
  "/consumables": "ConsumablesPage", "/reconciliation": "ReconciliationPage", "/handover": "HandoverPage",
  "/jobs": "JobsPage", "/plugs": "PlugLogPage", "/tasks": "TasksPage", "/data-fix": "DataFixPage", "/go-live": "GoLivePage", "/broker-quotes": "QuotesPage",
  "/week-plan": "WeekPlanPage", "/process-cards": "ProcessCardsPage", "/mtc": "MtcPage", "/inspections": "InspectionsPage", "/incoming-rm": "IncomingRmPage", "/approvals": "ApprovalsPage",
  "/portal-requests": "PortalRequestsPage", "/prices-view": "PricesViewPage", "/standards": "StandardsLibraryPage", "/daily-rates": "DailyRatesPage", "/dpr": "DprPage", "/stock-register": "StockRegisterViewPage", "/settings": "SettingsPage",
  "/scan": "CameraScanPage",
  "/security-gate": "GateRegisterPage",
  "/hr": "HrPage",
  "/job-roles": "JobRolesPage",
  "/org-chart": "OrgChartPage",
  "/people-master": "PeopleMasterPage",
  "/reports-inbox": "ReportsPage",
  "/documents": "DocumentsPage",
  "/manpower": "ManpowerPage",
  "/maintenance": "MaintenancePage",
  "/complaints": "ComplaintsPage",
  "/projects": "ProjectsPage",
  "/amc": "AmcPage",
};

const _prefetched = new Set();
export function prefetchRoute(path) {
  const key = ROUTE_MAP[path];
  if (!key || _prefetched.has(key)) return;
  _prefetched.add(key);
  importers[key]().catch(() => _prefetched.delete(key));
}

// Instant page shell shown while a route chunk downloads
export function PageSkeleton() {
  return (
    <div className="p-5 space-y-4 animate-pulse" data-testid="page-skeleton">
      <div className="h-6 w-56 bg-[#E8EBF0] rounded-sm" />
      <div className="flex gap-2">
        {[0, 1, 2, 3].map((i) => <div key={i} className="h-16 w-40 bg-[#EEF1F5] rounded-sm" />)}
      </div>
      <div className="h-72 bg-[#F1F3F6] rounded-sm" />
    </div>
  );
}
